// 숫자 포맷팅 유틸리티

/**
 * 평점을 안전하게 포맷팅
 */
export const formatRating = (rating: any): string => {
  if (!rating) return '0.0';
  
  const num = typeof rating === 'number' 
    ? rating 
    : parseFloat(rating);
  
  return isNaN(num) ? '0.0' : num.toFixed(1);
};

/**
 * 가격을 한국 원화 형식으로 포맷팅
 */
export const formatPrice = (price: any): string => {
  if (!price) return '0';
  
  const num = typeof price === 'number'
    ? price
    : parseInt(price);
  
  return isNaN(num) ? '0' : num.toLocaleString();
};

/**
 * 숫자를 안전하게 포맷팅
 */
export const formatNumber = (value: any, defaultValue: number = 0): number => {
  if (!value) return defaultValue;
  
  const num = typeof value === 'number'
    ? value
    : parseFloat(value);
  
  return isNaN(num) ? defaultValue : num;
};
